import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { PortfolioPage } from '../../../../../Constants/user';

import { set_go_to_page } from "../../../../../actions";

import './style.scss';

class MainPage extends PureComponent {
    constructor(props) {
        super(props);

        const language = PortfolioPage.find(({ lang }) => lang === props.lang);
        this.state = {
            language,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.lang !== this.props.lang) {
            const language = PortfolioPage.find(({ lang }) => lang === this.props.lang);

            this.setState({
               language,
            });
        }
    }

    render() {
        const { language: { page1, page2 } } = this.state;
        const { goToPage } = this.props;

        return (
            <div id="mainPortfolioPage">
                <div className="pageNames" onClick={() => goToPage(2)}>{page1}</div>
                <div className="pageNames" onClick={() => goToPage(1)}>{page2}</div>
            </div>
        )
    }
}

const mapStateToProps = ({ main: { lang } }) => ({
    lang,
});

const mapDispatchToProps = dispatch => ({
    goToPage: page => dispatch(set_go_to_page(page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);